import { campaignAxios } from "../client";

export const campaignList = () => {
	return campaignAxios
	  .get<any>(`/campaigns/list`)
	  .then((r) => r.data);
  };